import { useState } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';
import OutsideClickHandler from 'react-outside-click-handler';

// ---------------------------------------------------------

import Icon from '@components/icon';
import Button from '@components/button';

// ---------------------------------------------------------

import styles from '../styles.module.scss';
const {
  filter_apply_button,
  filter_button,
  filter_content_inner,
  filter_container,
  filters_are_showing,
  filter_content
} = styles;

// ---------------------------------------------------------

const FilterDropDownButton = (props) => {
  let { children, label, onApply } = props;

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const applyFilters = () => {
    onApply();
    setDropdownIsOpen(false);
  };

  // ---------------------------------------------------------

  return (
    <div
      className={classNames(filter_container, {
        [filters_are_showing]: dropdownIsOpen
      })}
    >
      <OutsideClickHandler onOutsideClick={() => setDropdownIsOpen(false)}>
        <button
          aria-expanded={dropdownIsOpen}
          aria-controls={label}
          className={filter_button}
          onClick={() => setDropdownIsOpen(!dropdownIsOpen)}
        >
          {label}
          <Icon name="small-down" type="arrow" />
        </button>

        <AnimateHeight
          animateOpacity={true}
          className={filter_content}
          contentClassName={filter_content_inner}
          duration={400}
          height={dropdownIsOpen ? 'auto' : 0}
          id={label}
        >
          {children}
          <Button
            className={filter_apply_button}
            type="button"
            label="Apply Filters"
            onClick={applyFilters}
          />
        </AnimateHeight>
      </OutsideClickHandler>
    </div>
  );
};

FilterDropDownButton.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  onApply: PropTypes.func
};

export default FilterDropDownButton;
